import { render, staticRenderFns } from "./windowsPortal.vue?vue&type=template&id=e6f0ff28&"
import script from "./windowsPortal.vue?vue&type=script&lang=js&"
export * from "./windowsPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports